import { useQuery } from 'react-query';

import { getRiskRegisterAuditLog as queryFn } from 'api/endPoints/getRiskRegisterAuditLog';
import { QueryKeys } from 'api/queryKeys';

import { IAssignee } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

export const useQueryGetRiskRegisterAuditLog = (params: QueryParams) => {
    return useQuery<QueryFnResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getRiskRegisterAuditLog', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.riskId),
    });
};

export interface QueryParams {
    riskId: number;
}

export interface QueryResponse {
    attributeName: string;
    oldValue: string;
    newValue: string;
    changeDate: number;
    changedBy: Omit<IAssignee, 'id'>;
}

interface QueryFnResponse {
    attributeName: string;
    oldValue: string;
    newValue: string;
    changeDate: number;
    changedBy: Omit<IAssignee, 'id'>;
}
